// extracted by mini-css-extract-plugin
export default {"loader":"u8x-3fhqsVoLBeupTkE9Aw==","loader__box":"MZKtp6DiFjHqk35Y5sZZ0g==","loader__icon":"-6KpxOOQCnshzTm7ctSvKQ==","spinner-rotate":"Z2IhMs-neV0CSVNQ1nBbqQ=="};